import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_info_circle_dark_blue.svg'
import _imports_1 from '@/app/ui/assets/svg/info-red.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "flex flex-col p-3 gap-y-3" }
const _hoisted_2 = { class: "flex flex-row gap-2 items-center pb-1" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-x-2 gap-y-3 items-start" }
const _hoisted_4 = { class: "flex flex-col gap-1 w-full mt-2" }
const _hoisted_5 = {
  key: 0,
  role: "status",
  class: "flex flex-row items-start rounded-lg bg-blue-lp-600 text-blue-lp-700 text-xs px-2.5 py-1 space-x-2 mt-2 border border-blue-lp-1100"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "info blue",
  class: "mt-px"
}, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1"
}
const _hoisted_8 = {
  key: 2,
  class: "flex flex-row items-start rounded bg-gray-lp-200 text-gray-lp-800 text-12px xxl:text-14px p-4 space-x-2 mt-2"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "info red"
}, null, -1)
const _hoisted_10 = {
  key: 3,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1 flex flex-row space-x-4"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "info red"
}, null, -1)
const _hoisted_12 = {
  key: 4,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1 flex flex-row space-x-4"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "info red"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_15 = { class: "col-span-2 flex flex-col" }
const _hoisted_16 = { class: "flex items-center gap-x-2" }
const _hoisted_17 = { class: "flex items-center gap-x-1 px-1.5 py-1" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectCustomer = _resolveComponent("SelectCustomer")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { rounded: "xl" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Icons, { name: "icon-detail-sender" }),
          _createVNode(_component_Title, {
            label: _ctx.$t('revamp.booking.detailRecipient'),
            fontSize: 14
          }, null, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.recipientNameBookingNew'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectCustomer, {
                column: "Penerima",
                placeholder: "bookingShipment.placeholder.recipientName",
                customerName: _ctx.modelValue.receiver,
                "onUpdate:customerName": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.receiver = $event)),
                  _ctx.onChangeName
                ],
                loading: _ctx.loadingCustomerList,
                options: _ctx.customerList,
                keyName: "customerPhoneNumber",
                error: !!_ctx.errorMessageName,
                errorCaption: _ctx.errorMessageName,
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFocusCustomer(_ctx.receiverNameIndex, _ctx.modelValue.receiver))),
                onSelect: _cache[3] || (_cache[3] =  (item) =>
                    _ctx.onSelectCustomer(
                      item,
                      _ctx.modelValue.isCOD || _ctx.modelValue.isDFOD
                    )
            ),
                disabled: _ctx.disabledName,
                class: "mt-2",
                isReverseJourney: _ctx.isReverseJourneyDetail,
                isBookingV3: true,
                useInfiniteScroll: "",
                onScrolled: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onScroll(_ctx.modelValue.receiver)))
              }, null, 8, ["customerName", "onUpdate:customerName", "loading", "options", "error", "errorCaption", "disabled", "isReverseJourney"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingV3.recipientPhoneNumber')
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_SelectPhoneCountry, {
                  column: "Penerima",
                  keyName: "customerName",
                  code: _ctx.modelValue.phoneCodeReceiver,
                  "onUpdate:code": [
                    _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.phoneCodeReceiver = $event)),
                    _ctx.onChangePhone
                  ],
                  phone: _ctx.modelValue.phoneReceiver,
                  "onUpdate:phone": [
                    _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.phoneReceiver = $event)),
                    _ctx.onChangePhone
                  ],
                  error: _ctx.errorMessagePhone,
                  isLoading: _ctx.loadingCustomerList,
                  options: _ctx.customerList,
                  onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onFocusCustomer(_ctx.receiverPhoneIndex, _ctx.fullPhoneNumber))),
                  onSelect: _cache[8] || (_cache[8] = (item) => _ctx.onSelectCustomer(
                        item,
                        _ctx.modelValue.isCOD || _ctx.modelValue.isDFOD
                      )
              ),
                  disabled: _ctx.disabledPhone,
                  isReverseJourney: _ctx.isReverseJourneyDetail,
                  isBookingV3: true,
                  useInfiniteScroll: "",
                  countryCodeButtonId: _ctx.countryCodeButtonId,
                  phoneNumberFieldId: _ctx.phoneNumberFieldId,
                  onScrolled: _cache[9] || (_cache[9] = () => _ctx.onScroll(_ctx.fullPhoneNumber))
                }, null, 8, ["code", "onUpdate:code", "phone", "onUpdate:phone", "error", "isLoading", "options", "disabled", "isReverseJourney", "countryCodeButtonId", "phoneNumberFieldId"])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingV3.recipientAddress'),
            class: "col-span-2 w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                type: "textarea",
                preventEnterTextArea: "",
                showMaxLength: "",
                textAreaRows: "1",
                modelValue: _ctx.modelValue.addressReceiver,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.modelValue.addressReceiver = $event)),
                error: !!_ctx.errorMessageAddress,
                "error-caption": _ctx.errorMessageAddress,
                format: _ctx.replaceNewLine,
                placeholder: "bookingShipment.placeholder.recipientAddress",
                maxLength: _ctx.maxAddressLength,
                disabled: _ctx.disabledAddress,
                disableBackground: _ctx.disabledAddress,
                onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.receiverAddressIndex))),
                onChange: _ctx.onValidateAddress,
                pbTextAreaWithLength: "pb-7"
              }, null, 8, ["modelValue", "error", "error-caption", "format", "maxLength", "disabled", "disableBackground", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.districtDestinationCity'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                class: "mt-2",
                onFilter: _ctx.fetchDestinationCity,
                useInfiniteScroll: "",
                onScrolled: _ctx.onScrollDistrict,
                isLoading: _ctx.isLoadingDestinationCity,
                options: _ctx.destinationCityList,
                keyName: "name",
                keyValue: "id",
                placeholder: 
              _ctx.$t('bookingShipment.placeholder.districtDestinationCity')
            ,
                modelValue: _ctx.modelValue.destinationCity,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.modelValue.destinationCity = $event)),
                errorMessage: 
              _ctx.$t('bookingV3.receiverDestinationCity.error.notfound')
            ,
                isShowErrorIndicator: 
              !!_ctx.errorMessageDestination ||
                _ctx.isErrorEmbargo ||
                _ctx.isErrorRouteNotFound
            ,
                errorCaption: _ctx.errorMessageDestination,
                onFocus: _ctx.onGetDestinationCity,
                onBlur: _ctx.onFocusDestinationCity,
                onChange: _ctx.onSelectDestinationCity,
                isDisabled: _ctx.disabledDistrict,
                disabledBackground: _ctx.disabledDistrict,
                onClear: _ctx.clearSearch
              }, null, 8, ["onFilter", "onScrolled", "isLoading", "options", "placeholder", "modelValue", "errorMessage", "isShowErrorIndicator", "errorCaption", "onFocus", "onBlur", "onChange", "isDisabled", "disabledBackground", "onClear"]),
              (_ctx.showMisbookingGuidance)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.receiverDestinationCity.misbookingGuidance")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.destinationCity?.status === 'INACTIVE')
                ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(this.$t("bookingShipment.error.inactiveCity")), 1))
                : _createCommentVNode("", true),
              (_ctx.checkVendorDestinationDistrict)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.districtOnePiece")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isErrorEmbargo)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(this.$t("bookingShipment.error.embargo")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isErrorRouteNotFound)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(this.$t("bookingShipment.error.routeNotFound")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.postalCode'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                serverSide: false,
                placeholder: _ctx.$t('bookingShipment.placeholder.postalCode'),
                class: "mt-2",
                keyName: "name",
                keyValue: "name",
                options: _ctx.postalCodeList,
                modelValue: _ctx.modelValue.postalCodeDestination,
                "onUpdate:modelValue": [
                  _cache[13] || (_cache[13] = ($event: any) => (_ctx.modelValue.postalCodeDestination = $event)),
                  _ctx.onChangePostalCode
                ],
                errorMessage: _ctx.$t('bookingV3.receiverPostalCode.error.notfound'),
                isShowErrorIndicator: _ctx.isEditShipment ? false : !!_ctx.errorMessagePostalCode,
                isShowErrorMessage: 
              !!_ctx.errorMessagePostalCode || !_ctx.postalCodeList.length
            ,
                errorCaption: _ctx.isEditShipment ? '' : _ctx.errorMessagePostalCode,
                onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.receiverPostalCodeIndex))),
                onFilter: _ctx.onGetPostalCodeList,
                isDisabled: _ctx.disabledPostalCode,
                disabledBackground: _ctx.disabledPostalCode,
                onKeypress: _ctx.allowOnlyNumeric
              }, null, 8, ["placeholder", "options", "modelValue", "errorMessage", "isShowErrorIndicator", "isShowErrorMessage", "errorCaption", "onUpdate:modelValue", "onFilter", "isDisabled", "disabledBackground", "onKeypress"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.$slots['destination-info'])
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _renderSlot(_ctx.$slots, "destination-info")
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAddressType, (item, index) => {
                return (_openBlock(), _createBlock("label", {
                  key: index,
                  for: item.value,
                  class: [
                _ctx.modelValue.addressReceiverType.value === item.value
                  ? 'border-red-lp-100 bg-red-lp-50 text-red-lp-100'
                  : 'border-gray-lp-1300 text-gray-lp-800'
              , "relative cursor-pointer block overflow-hidden border rounded-md focus-within:border-blue focus-within:ring-2 focus-within:ring-blue"]
                }, [
                  _createVNode("input", {
                    type: "radio",
                    value: _ctx.modelValue.addressReceiverType.value,
                    checked: _ctx.modelValue.addressReceiverType.value === item.value,
                    id: item.value,
                    name: "addressType",
                    onChange: () => _ctx.onSelectAddressType(item),
                    class: "z-10 absolute opacity-0"
                  }, null, 40, ["value", "checked", "id", "onChange"]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode(_component_Icons, {
                      name: item.value === 'home' ? 'home-type' : 'office'
                    }, null, 8, ["name"]),
                    _createVNode("span", _hoisted_18, _toDisplayString(item.name), 1)
                  ])
                ], 10, ["for"]))
              }), 128))
            ]),
            _withDirectives(_createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.error.addressType")), 1)
            ], 512), [
              [_vShow, !_ctx.modelValue.addressReceiverType]
            ])
          ]),
          _createVNode("div", {
            class: 
            `${
              _ctx.disabledSaveAddress
                ? 'p-field-checkbox-grey cursor-not-allowed'
                : 'p-field-checkbox'
            } flex items-center gap-x-2.5 relative`
          
          }, [
            _createVNode(_component_Checkbox, {
              id: "recipient",
              modelValue: _ctx.modelValue.isSaveReceiver,
              "onUpdate:modelValue": [
                _cache[15] || (_cache[15] = ($event: any) => (_ctx.modelValue.isSaveReceiver = $event)),
                _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.saveReceiverIndex)))
              ],
              binary: "",
              disabled: _ctx.disabledSaveAddress
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", {
              for: "sender",
              class: [{ 'text-gray-lp-500': false }, "text-sm text-black-lp-300"]
            }, _toDisplayString(_ctx.$t("bookingShipment.column.saveReceiver")), 1)
          ], 2)
        ])
      ])
    ]),
    _: 3
  }))
}